import React from 'react';
import { cn } from '../lib/utils';
import VerifiedBadge from './VerifiedBadge';
import { Link } from 'react-router-dom';

interface UserNameProps {
  name: string;
  verified?: boolean;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
  truncate?: boolean;
  userId?: string;
  disableLink?: boolean;
}

const UserName = ({ 
  name, 
  verified, 
  className, 
  size = 'md', 
  showTooltip = false,
  truncate = false,
  userId,
  disableLink = false
}: UserNameProps) => {
  const sizeClasses = {
    xs: 'text-xs gap-1',
    sm: 'text-sm gap-1',
    md: 'text-base gap-1.5',
    lg: 'text-lg gap-2',
  };

  const content = (
    <>
      <span className={cn(
        'font-medium',
        truncate && 'truncate'
      )}>
        {name}
      </span>
      {verified && (
        <VerifiedBadge 
          size={size} 
          showTooltip={showTooltip}
        />
      )}
    </>
  );

  // If userId is provided and links are enabled, make it a link
  if (userId && !disableLink) {
    return (
      <Link 
        to={`/users/${userId}`}
        className={cn(
          'flex items-center hover:text-accent transition-colors', 
          sizeClasses[size], 
          truncate && 'max-w-full',
          className
        )}
      >
        {content}
      </Link>
    );
  }

  // Otherwise, render as a regular div
  return (
    <div className={cn(
      'flex items-center', 
      sizeClasses[size], 
      truncate && 'max-w-full',
      className
    )}>
      {content}
    </div>
  );
};

export default UserName;